export const KizInventoryItemCorrectStatusPluginSettings: IPluginSettings = {
    name: "Статусы корректирующих схем",
    mnemocode: "kiz_inventory_item_correct_status_plugin",
    permission: "KizInventory",
    columns: [
        {
            order: 0,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "ИД",
            visibility: false,
            width: 200,
        },
        {
            order: 1,
            propertyName: "idDocumentGlobal",
            propertyType: "string",
            displayName: "idDocumentGlobal",
            visibility: false,
            width: 200,
        },
        {
            order: 2,
            propertyName: "kizInventoryName",
            propertyType: "string",
            displayName: "Киз инвенторизация",
            visibility: false,
            width: 200,
        },
        {
            order: 3,
            propertyName: "sgtin",
            propertyType: "string",
            displayName: "Sgtin (КИЗ)",
            visibility: true,
            width: 200,
        },
        {
            order: 4,
            propertyName: "mdlpError",
            propertyType: "string",
            displayName: "Ошибка МДЛП",
            visibility: true,
            width: 200,
        },
        {
            order: 5,
            propertyName: "idError",
            propertyType: "string",
            displayName: "Код ошибки",
            visibility: true,
            width: 200,
        },
        {
            order: 6,
            propertyName: "state",
            propertyType: "string",
            displayName: "Статус",
            visibility: true,
            width: 200,
        },
        {
            order: 7,
            propertyName: "dateCreated",
            propertyType: "date",
            displayName: "Дата создания",
            visibility: false,
            width: 100,
        },
        
    ],
    detailsPlugins: [],
};